import styled from 'styled-components';

export const SubHeaderContainer = styled.div`
  background-color: #ffffff;
  border-color: #747480;
  border-bottom: 1rem;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  align-items: center;

  @media (max-width: 768px) {
    border-bottom: 1px solid #000000;
    flex-direction: column;
    align-items: unset;
  }
`;
export const SubHeaderContainerGcsp = styled.div`
  background-color: #ffffff;
  border-color: #747480;
  border-bottom: 1rem;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  align-items: center;
  height: 20%;
`;

export const SubHeaderTopContainerGcsp = styled.div`
  background-color: #3a3a4a;
  border-color: #747480;
  border-bottom: 1rem;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  align-items: center;
  height: 20%;
`;
export const SubmitButtonContainer = styled.div`
  box-sizing: border-box;
  height: 10%;
  display: flex;
  flex-direction: row;
  align-items: end;
  column-gap: 10px;
  flex: 1;
  justify-content: flex-end;
`;

export const TitleContainer = styled.span`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding-top: 15px;
  padding-bottom: 15px;
`;
export const TitleTextContainer = styled.span`
  display: flex;
  flex-direction: column;
`;

export const SubHeaderTitle = styled.span`
  display: flex;
  flex-direction: column;
`;

export const QuarterTitle = styled.span`
  color: #000000;
  font-family: 'EYInterstate';
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  display: flex;
  flex-direction: row;
`;
export const SubHeaderTopTitle = styled.span`
  display: flex;
  flex-direction: row;
`;

export const TitleAccount = styled.span`
  color: #ffffff;
  font-family: 'EYInterstate';
  font-size: 20px;
  font-weight: 600;
  text-align: left;
`;
export const TitleText = styled.span`
  color: #ffffff;
  font-family: 'EYInterstate';
  font-size: 20px;
  font-weight: 300;
  margin-left: 10px;
  text-align: left;
`;

export const SubHeaderTopHyperlink = styled.span`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
`;

export const QuarterDates = styled.span`
  color: #000000;
  font-family: 'EYInterstate';
  font-size: 13px;
  font-weight: 300;
  text-align: left;
`;

export const Hyperlink = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;

export const HyperlinkText = styled.span`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #2e2e38;
`;

export const Divider = styled.span`
  width: 1px;
  background-color: #c4c4cd;
  height: 43px;
`;

export const ChipContainer = styled.span`
  padding-left: 10px;
`;

export const TabStep = styled.div`
  font-family: 'EYInterstate';
  font-size: 13px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
`;

export const TabMonth = styled.div`
  font-family: 'EYInterstate';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
`;

export const TabDates = styled.div`
  font-family: EYInterstate;
  font-size: 13px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
`;

export const TabPrevButton = styled.div`
  width: 145px;
  height: 44px;
  padding: 11px 36px;
  border-width: 1px;
  color: #000000;
`;

export const TabNextButton = styled.div`
  width: 145px;
  height: 44px;
  padding: 11px 36px;
  border-width: 1px;
  color: #000000;
`;
